import {
  SnackbarNotificationTypes,
  updateSnackbarNotification,
} from "@src/reducers/your-reducer";
import store from "@src/reducers/store";

const DEFAULT_TIMEOUT = 2500;

export const successSnackbar = (
  text: string,
  timeOut: number = DEFAULT_TIMEOUT,
) => {
  const snackbar: SnackbarNotificationTypes = {
    type: "success",
    text: text,
    state: "open",
    timeOut: timeOut,
  };
  store.dispatch(updateSnackbarNotification(snackbar));
};

export const errorSnackbar = (
  text: string,
  timeOut: number = DEFAULT_TIMEOUT,
) => {
  const snackbar: SnackbarNotificationTypes = {
    type: "error",
    text: text,
    state: "open",
    timeOut: timeOut,
  };
  store.dispatch(updateSnackbarNotification(snackbar));
};

export const reminderSnackbar = (
  text: string,
  timeOut: number = DEFAULT_TIMEOUT,
) => {
  const snackbar: SnackbarNotificationTypes = {
    type: "reminder",
    text: text,
    state: "open",
    timeOut: timeOut,
  };
  store.dispatch(updateSnackbarNotification(snackbar));
};

export const warningSnackbar = (
  text: string,
  timeOut: number = DEFAULT_TIMEOUT,
) => {
  const snackbar: SnackbarNotificationTypes = {
    type: "warning",
    text: text,
    state: "open",
    timeOut: timeOut,
  };
  store.dispatch(updateSnackbarNotification(snackbar));
};
